module.exports = __webpack_public_path__ + "img/71.a951e921.svg";